import { api } from './api';

export const generationInstructionTemplatesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getArchitectInstructionTemplates: builder.query({
      query: () => '/admin/generation-instruction-templates/architect',
      providesTags: ['ArchitectInstructionTemplate'],
    }),
    putArchitectInstructionTemplates: builder.mutation({
      query: (templates) => ({
        url: '/admin/generation-instruction-templates/architect',
        method: 'PUT',
        body: { templates },
      }),
      invalidatesTags: ['ArchitectInstructionTemplate'],
    }),
  }),
});

export const {
  useGetArchitectInstructionTemplatesQuery,
  usePutArchitectInstructionTemplatesMutation,
} = generationInstructionTemplatesApi;
